/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Faq_2_QuestionInputs */

const en_svc_n8n_faq_2_question = /** @type {(inputs: Svc_N8n_Faq_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should we self-host n8n or use n8n Cloud?`)
};

const lv_svc_n8n_faq_2_question = /** @type {(inputs: Svc_N8n_Faq_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai n8n mitināt pašiem vai izmantot n8n Cloud?`)
};

/**
* | output |
* | --- |
* | "Should we self-host n8n or use n8n Cloud?" |
*
* @param {Svc_N8n_Faq_2_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_faq_2_question = /** @type {((inputs?: Svc_N8n_Faq_2_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Faq_2_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_faq_2_question(inputs)
	return en_svc_n8n_faq_2_question(inputs)
});